import EventCard from './EventCard/EventCard';
import { useRevealGroup } from 'hooks/useReveal';
import './MonthSection.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Місяць календаря — ADR-0005, ADR-0008.
 *
 * Було: Swiper зі стрілками-«шевронами» на скошених div, шістьма брейкпойнтами
 * і useEffect, який через parent.innerHTML вставляв рядок з React-атрибутом
 * className у чистий HTML. Заходи в місяці можна було переглядати лише прокруткою
 * вбік, при цьому кількість заходів заздалегідь невідома.
 *
 * Стало: звичайна сітка. Усі заходи місяця видно одразу, DOM ніхто не перезаписує.
 */
export default function MonthSection({ month, monthIdx, events }) {
  const language = useLanguage();
  const monthEvents = events.filter((event) => new Date(event.start).getMonth() === monthIdx);
  const gridRef = useRevealGroup('.event-card', { step: 40 }, monthEvents.length);

  return (
    <section className='calendar-month'>
      <div className='container'>
        <h2 className='calendar-month-title'>
          {month}
          <span className='calendar-month-count tnum' aria-hidden='true'>
            {monthEvents.length}
          </span>
        </h2>

        {monthEvents.length > 0 ? (
          <div className='events-grid' ref={gridRef}>
            {monthEvents.map((event) => (
              <EventCard event={event} key={event.id} />
            ))}
          </div>
        ) : (
          <p className='empty-note'>
            {language === 'en' ? 'There are no events this month.' : 'Цього місяця заходів немає.'}
          </p>
        )}
      </div>
    </section>
  );
}
